/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createNthRoot } from '../../factoriesAny.js';
export var nthRootDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createNthRoot: createNthRoot
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNthRoot.generated.js
// module id = 1466
// module chunks = 0